import type { QuickscanQuestion } from '@wtta/scoring'

interface QuestionStepProps {
  question: QuickscanQuestion
  selectedValue: string | undefined
  questionNumber: number
  totalQuestions: number
  onAnswer: (value: string) => void
  onBack: (() => void) | null
}

export function QuestionStep({
  question,
  selectedValue,
  questionNumber,
  totalQuestions,
  onAnswer,
  onBack,
}: QuestionStepProps) {
  const progressPercent = Math.round(((questionNumber - 1) / totalQuestions) * 100)

  return (
    <section className="wtta-step wtta-step--question" data-testid="question-step">
      <div className="wtta-progress" aria-label={`Vraag ${questionNumber} van ${totalQuestions}`}>
        <div className="wtta-progress__bar" style={{ width: `${progressPercent}%` }} />
        <span className="wtta-progress__label">
          Vraag {questionNumber} / {totalQuestions}
        </span>
      </div>

      <h2 className="wtta-title">{question.question}</h2>
      {question.helpText ? <p className="wtta-help">{question.helpText}</p> : null}

      <div className="wtta-options" role="radiogroup" aria-label={question.question}>
        {question.options.map((option) => {
          const isSelected = selectedValue === option.value
          return (
            <button
              key={option.value}
              type="button"
              role="radio"
              aria-checked={isSelected}
              className={`wtta-option${isSelected ? ' wtta-option--selected' : ''}`}
              data-testid={`option-${question.id}-${option.value}`}
              onClick={() => onAnswer(option.value)}
            >
              <span className="wtta-option__label">{option.label}</span>
            </button>
          )
        })}
      </div>

      {onBack ? (
        <button
          type="button"
          className="wtta-button wtta-button--ghost"
          onClick={onBack}
          data-testid="back-button"
        >
          ← Vorige
        </button>
      ) : null}
    </section>
  )
}
